/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/Search': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M17.826 22.556c-4.289 0-7.777-3.489-7.777-7.778C10.049 10.49 13.538 7 17.826 7s7.777 3.49 7.777 7.778c0 4.289-3.489 7.778-7.777 7.778m0-17.556c-5.4 0-9.777 4.378-9.777 9.778 0 2.34.824 4.486 2.194 6.169l-5.17 5.17a.249.249 0 0 0 0 .353l1.061 1.061a.25.25 0 0 0 .353 0l5.17-5.17a9.733 9.733 0 0 0 6.17 2.195c5.398 0 9.776-4.378 9.776-9.778S23.226 5 17.827 5"/>'
  }
})
